/**
 * The incentive history's cache key (useGetListIncentives: [key, enrollmentId, page, pageSize]).
 *
 * Kept in its own module so the visit paths that must refresh it can import it without pulling in
 * the hooks (and so a test that mocks the hooks still gets the real key). Invalidating `[key]`
 * matches every enrollment and page by prefix.
 */
export const INCENTIVE_HISTORY_QUERY_KEY = "get-benefiary-get-list-incentives";
